import { img } from "./images";

export const blogs = [
  {
    id: "new-fleet-launch",
    title: "We're Launching a Modern, Eco-Friendly Taxi Fleet",
    category: "Service Updates",
    tags: ["fleet", "eco-friendly", "news"],
    date: "March 12, 2025",
    author: "Taxi24hrs Team",
    image: img("1549317661-bd32c8ce0db2", 800, 500),
    excerpt:
      "A modern and clean fleet makes a huge difference. Discover our new eco-friendly vehicles built for comfort and sustainability.",
    content: [
      "We're thrilled to announce the launch of our brand-new, modern and eco-friendly taxi fleet. Sustainable travel is the future, and we're proud to lead the way in our city.",
      "Each new vehicle is fitted with premium interiors, climate control and the latest safety technology, ensuring every ride is comfortable and secure.",
      "Our hybrid and electric vehicles dramatically reduce emissions without compromising on performance, so you can travel with a clear conscience.",
    ],
    comments: [
      { name: "James Carter", text: "This is fantastic! A modern and clean fleet makes a huge difference. Looking forward to my next ride." },
      { name: "Sophia Lewis", text: "Absolutely! Having new, well-maintained vehicles makes the experience much more enjoyable." },
    ],
  },
  {
    id: "airport-travel-tips",
    title: "Smart Travel Tips for Stress-Free Airport Transfers",
    category: "Travel Tips",
    tags: ["airport", "tips", "booking"],
    date: "March 5, 2025",
    author: "Sophie Allen",
    image: img("1436491865332-7a61a109cc05", 800, 500),
    excerpt:
      "Pre-booking makes a huge difference. Here are our top tips for smooth, on-time airport transfers every single time.",
    content: [
      "Airport transfers can be stressful, but a little planning goes a long way. Always pre-book your ride to avoid last-minute scrambling.",
      "Choose a vehicle with enough luggage space for your trip — our airport taxis offer generous room for bags and equipment.",
      "Enable real-time tracking so you always know exactly where your driver is, especially for early morning flights.",
    ],
    comments: [
      { name: "Emily Brown", text: "Great tips! I always struggle with airport transfers, so these insights are really helpful." },
      { name: "Michael Smith", text: "Same here! Pre-booking makes a huge difference." },
    ],
  },
  {
    id: "tech-in-taxis",
    title: "How Technology Is Transforming the Taxi Experience",
    category: "Customer Stories",
    tags: ["technology", "innovation"],
    date: "February 24, 2025",
    author: "Avery Morgan",
    image: img("1502920917128-1aa500764cbd", 800, 500),
    excerpt:
      "Real-time tracking and digital payments have made taxi rides more convenient than ever. Here's a look at the innovations.",
    content: [
      "Technology is reshaping how we move around our cities. Real-time tracking, digital payments and smart routing have made rides faster and more convenient.",
      "Our app uses AI-driven driver matching to connect you with the nearest available car, reducing wait times significantly.",
      "Digital receipts, saved locations and in-app support put complete control of your journey right in your pocket.",
    ],
    comments: [
      { name: "Daniel Carter", text: "Real-time tracking and digital payments have made taxi rides so much more convenient. Great to see these innovations!" },
      { name: "Sarah Green", text: "Absolutely! Sustainable transport options make a big difference for the environment." },
    ],
  },
  {
    id: "booking-tips",
    title: "Booking Tips: Save Time on Every Ride",
    category: "Booking Tips",
    tags: ["booking", "tips"],
    date: "February 15, 2025",
    author: "Taxi24hrs Team",
    image: img("1570125909232-eb263c188f7e", 800, 500),
    excerpt:
      "Using saved locations and pre-booking can make your daily commute a breeze. Here's how to get the most out of Taxi24hrs.",
    content: [
      "Small habits can make a big difference to your daily commute. Save your home and work addresses for one-tap booking.",
      "Schedule recurring rides for regular appointments so you never have to think about it again.",
      "Pre-booking for early morning flights guarantees a driver will be ready when you are.",
    ],
    comments: [
      { name: "Emily White", text: "I always use pre-booking for airport rides. It saves so much time and stress!" },
      { name: "Ryan Carter", text: "Using saved locations in the app has made my daily commute a breeze. Highly recommend it!" },
    ],
  },
];

export const blogCategories = [
  "Service Updates",
  "Travel Tips",
  "Customer Stories",
  "Booking Tips",
];

export const caseStudies = [
  {
    id: "app-enhancements",
    title: "App Enhancements",
    client: "Innovate Solutions",
    industry: "Tech Startups & Enterprises",
    category: "Technology Integration",
    duration: "8 weeks",
    location: "New York, USA",
    image: img("1551288049-bebda4e38f71", 800, 550),
    challenges: [
      "User adoption challenges",
      "Performance optimization issues",
      "Security vulnerabilities",
      "Integration with third-party services",
    ],
    approach:
      "We implemented a strategic approach focusing on performance upgrades, enhanced security, and intuitive design improvements.",
    solutions: [
      "Modernized app architecture",
      "Enhanced security protocols",
      "User-centric UI/UX redesign",
      "Seamless third-party integrations",
      "Scalability improvements for future growth",
    ],
    results: [
      "40% increase in user engagement",
      "Faster load times and responsiveness",
      "Enhanced security and compliance",
      "Higher customer satisfaction scores",
    ],
  },
  {
    id: "fleet-scaling",
    title: "Fleet Scaling",
    client: "Swift Transit Solutions",
    industry: "Logistics & Transportation",
    category: "Service Expansion",
    duration: "10 weeks",
    location: "Chicago, USA",
    image: img("1511919884226-fd3cad34687c", 800, 550),
    challenges: [
      "Driver recruitment and training",
      "Route and fuel efficiency optimization",
      "Maintenance and repair costs",
      "Regulatory compliance and safety measures",
    ],
    approach:
      "We developed a structured fleet expansion plan that balanced cost-effectiveness, efficiency, and sustainability.",
    solutions: [
      "Fleet procurement strategy with cost-effective leasing",
      "Advanced telematics for real-time tracking",
      "Driver training programs for safety and efficiency",
      "Predictive maintenance scheduling",
      "Integration of eco-friendly vehicle options",
    ],
    results: [
      "25% increase in delivery capacity",
      "Improved fuel efficiency by 15%",
      "Reduced vehicle downtime",
      "Enhanced driver performance and safety",
    ],
  },
  {
    id: "gps-implementation",
    title: "GPS Implementation",
    client: "Metro Logistics",
    industry: "Logistics & Taxi Service Providers",
    category: "Technology Integration",
    duration: "7 weeks",
    location: "Los Angeles, USA",
    image: img("1503376780353-7e6692767b70", 800, 550),
    challenges: [
      "Minimizing system downtime during installation",
      "Managing data security and privacy concerns",
      "Optimizing GPS accuracy in urban environments",
    ],
    approach:
      "We deployed a structured implementation plan focused on efficiency and user adaptability.",
    solutions: [
      "Selected a scalable and feature-rich GPS solution",
      "Developed a phased installation plan",
      "Conducted hands-on training sessions",
      "Integrated real-time tracking with analytics",
      "Implemented data encryption and security protocols",
    ],
    results: [
      "25% reduction in fuel consumption",
      "Improved delivery and pick-up accuracy",
      "Enhanced driver accountability",
      "Faster response times and reliability",
    ],
  },
  {
    id: "safety-enhancements",
    title: "Safety Enhancements",
    client: "SafeRide Solutions",
    industry: "Taxi & Ride-Sharing Companies",
    category: "Customer Satisfaction",
    duration: "6 weeks",
    location: "Houston, USA",
    image: img("1449965408869-eaa3f722e40d", 800, 550),
    challenges: [
      "Ensuring compliance with evolving safety regulations",
      "Minimizing distractions while integrating new tech",
      "Enhancing safety without reducing efficiency",
      "Gaining customer trust through visible safety measures",
    ],
    approach:
      "We introduced a series of strategic safety upgrades focused on prevention and response.",
    solutions: [
      "Installed in-car panic buttons and emergency alerts",
      "Integrated AI-powered driver monitoring",
      "Upgraded in-car surveillance",
      "Enhanced customer support with 24/7 safety assistance",
      "Launched driver safety training programs",
    ],
    results: [
      "20% increase in customer satisfaction ratings",
      "Reduction in safety-related incidents",
      "Faster emergency response times",
      "Strengthened brand reputation",
    ],
  },
];

export const careers = [
  {
    id: "taxi-driver",
    title: "Taxi Driver",
    type: "Full Time",
    schedule: "Standard Business Hours",
    salary: "$40K - $50K",
    positions: "Multiple Positions Available",
    location: "Company, City",
    experience: "Previous Driving Experience Preferred",
    desc: "Join our team of professional drivers and deliver safe, comfortable journeys to our valued passengers.",
    responsibilities: [
      "Provide excellent customer service and ensure passenger comfort.",
      "Maintain vehicle cleanliness and report any maintenance issues.",
      "Follow traffic laws and company policies.",
      "Utilize GPS navigation and optimize routes for efficiency.",
    ],
    requirements: [
      "Valid driver's license with a clean driving record.",
      "Strong knowledge of local roads and traffic laws.",
      "Good communication and customer service skills.",
      "Ability to work flexible hours, including weekends and holidays.",
      "Previous taxi or rideshare driving experience is a plus.",
    ],
  },
  {
    id: "dispatch-coordinator",
    title: "Dispatch Coordinator",
    type: "Full Time",
    schedule: "Monday to Friday",
    salary: "$50K - $60K",
    positions: "Multiple Positions Available",
    location: "Company, City",
    experience: "Prior Dispatch or Customer Service Experience Preferred",
    desc: "Coordinate trips and keep our drivers and customers connected for a seamless ride experience.",
    responsibilities: [
      "Assign trips to drivers based on location and availability.",
      "Communicate with customers and drivers via phone or dispatch software.",
      "Ensure timely pickups and drop-offs while optimizing routes.",
      "Handle customer inquiries and provide exceptional service.",
      "Maintain accurate records of trips and driver activity.",
    ],
    requirements: [
      "Previous experience in dispatching or customer service preferred.",
      "Strong communication and multitasking skills.",
      "Ability to work in a fast-paced environment and make quick decisions.",
      "Familiarity with dispatch software and GPS tracking systems.",
      "Excellent problem-solving and organizational skills.",
    ],
  },
  {
    id: "customer-service-rep",
    title: "Customer Service Representative",
    type: "Full Time",
    schedule: "Standard Business Hours",
    salary: "$40K - $50K",
    positions: "Multiple Positions Available",
    location: "Company, City",
    experience: "Prior Customer Service Experience Preferred",
    desc: "Be the friendly voice of Taxi24hrs, assisting customers with bookings and support.",
    responsibilities: [
      "Assist customers with taxi bookings, cancellations, and modifications.",
      "Provide information on pricing, services, and policies.",
      "Resolve customer complaints and escalate issues as needed.",
      "Maintain accurate records of customer interactions.",
      "Work closely with dispatch and drivers to ensure seamless service.",
    ],
    requirements: [
      "Previous experience in customer service or call center preferred.",
      "Strong verbal and written communication skills.",
      "Ability to multitask and handle high call volumes efficiently.",
      "Problem-solving skills and a customer-first mindset.",
      "Familiarity with booking systems and CRM software is a plus.",
    ],
  },
  {
    id: "fleet-manager",
    title: "Fleet Manager",
    type: "Full Time",
    schedule: "Monday to Friday",
    salary: "$60K - $75K",
    positions: "1 Position Available",
    location: "Company, City",
    experience: "Minimum 3 Years in Fleet Management",
    desc: "Oversee our growing fleet, ensuring every vehicle is safe, efficient and road-ready.",
    responsibilities: [
      "Monitor vehicle maintenance schedules and coordinate repairs as needed.",
      "Supervise drivers and enforce company policies and safety standards.",
      "Track fleet performance and optimize routes to enhance service quality.",
      "Ensure compliance with local transportation laws and regulations.",
      "Oversee fuel and expense management to maximize cost efficiency.",
    ],
    requirements: [
      "Proven experience in fleet management or logistics.",
      "Strong leadership and organizational skills.",
      "Knowledge of vehicle maintenance and safety standards.",
      "Proficiency in fleet management software is a plus.",
      "Ability to handle operational challenges in a fast-paced environment.",
    ],
  },
];

export const careerBenefits = [
  "Explore abundant opportunities for career growth and advancement within the taxi service industry.",
  "Participate in specialized training programs designed to enhance your skills in customer service and driving.",
  "Enjoy attractive salary packages and benefits, providing financial stability.",
  "Benefit from flexible working hours that allow you to balance your personal commitments.",
  "Experience a collaborative and supportive team environment where teamwork is encouraged.",
  "Unlock significant opportunities for personal and professional growth.",
];
